import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, X } from "lucide-react";

export default function RidePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("ride_popup_seen")) return;
    const t = setTimeout(() => setOpen(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    sessionStorage.setItem("ride_popup_seen", "1");
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && close();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center p-4 bg-navy/50 backdrop-blur-sm"
          onClick={close}
          role="dialog"
          aria-modal="true"
          aria-label="Help getting home to vote"
          data-testid="ride-popup"
        >
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.98 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative bg-white max-w-md w-full rounded-lg shadow-2xl p-8 md:p-10 text-center"
          >
            <button
              onClick={close}
              aria-label="Close popup"
              className="absolute top-3 right-3 text-steel hover:text-navy p-2 rounded-full hover:bg-navy/5 transition-colors"
              data-testid="ride-popup-close"
            >
              <X className="w-5 h-5" />
            </button>
            <div className="w-12 h-12 rounded-full bg-electric/10 text-electric flex items-center justify-center mx-auto mb-5">
              <Phone className="w-5 h-5" />
            </div>
            <h3 className="font-serif text-2xl md:text-3xl font-bold text-navy mb-3">
              Need help getting home to vote?
            </h3>
            <p className="text-navy/70 text-sm md:text-base leading-relaxed mb-7">
              If you need help coming home to vote on November 3rd, call Scott Satermo and he&rsquo;ll see what he can do for you!
            </p>
            <a
              href="tel:+17013618734"
              className="inline-flex items-center justify-center gap-2 bg-electric hover:bg-electric-hover text-white text-sm font-bold uppercase tracking-[0.15em] px-7 py-4 rounded-full transition-colors w-full sm:w-auto"
              data-testid="ride-popup-call"
            >
              <Phone className="w-4 h-4" /> Call Scott — 701-361-8734
            </a>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
